import React from 'react'

const Error = () => {
  return (
    <div className=' flex justify-center items-center text-3xl text-[#ff3737]'>
        Error - 404 not found
    </div>
  )
}

export default Error